/**
 * Internal dependencies
 */
import pb from './instance';

export const getFileUrl = (record?: Record<string, any>, file?: string) =>
	record && file && pb.files.getURL(record, file);
